import React, { useEffect, useState, useRef } from "react";
import { InsuranceCard } from "component/common/InsuranceCard";
import { NormalSearch } from "component/common/NormalSearch";
import { NormalRadioButton } from "component/common/NormalRadioButton";
import { NormalButton } from "component/common/NormalButton";
import { RewardCard } from "component/common/RewardCard";
import PhoneNumberInput from "component/common/PhoneNumberInput/index";
import policyCar from "assets/svg/policyCarBlue.svg";
import coverage from "assets/svg/coverageBlue.svg";
import renew from "assets/svg/renewBlue.svg";
import claim from "assets/svg/claimBlue.svg";
import accident from "assets/svg/towcarBlue.svg";
import agent from "assets/svg/carAgentBlue.svg";
import mvpi from "assets/svg/mvpiBlue.svg";
import single from "assets/svg/single.svg";
import singleOrange from "assets/svg/single_orange.svg";
import group from "assets/svg/Groupsme.svg";
import groupWhite from "assets/svg/Groupsme_white.svg";
import KSAFlagImage from "assets/images/ksa_flag.png";
import IndiaFlagImage from "assets/images/indiaFlag.png";
import iquamaIcon from "assets/svg/iquamaIcon.svg";
import calenderIcon from "assets/svg/motor/calender.svg";
import buynowArrow from "assets/svg/buynowArrow.svg";
import addManage from "assets/svg/addManage.svg";
import "./style.scss";
import { DownloadPolicy } from "assets/svg/motor/ValueAddedIcons";
import { getI18n, useTranslation } from "react-i18next";
import { GenericButton } from "component/common/Buttons/GenericButton";
import Birthday from "assets/images/mobile/Birthday.png";
import { NormalSelect } from "component/common/NormalSelect";
import selectArrow from "assets/svg/selectArrowIconHome.svg";
import { getGregYearOfBirthList, getHijriYearOfBirthList } from "helpers/utils";
import { useFormik } from "formik";
import OtpPage from "../../common/OtpScreen/otpPage";
import * as Yup from "yup";
import { updateLoader } from "../../../action/DashboardInformation";
import instance from "../../../service/instance";
import { store } from "../../../service/helpers";
import { Toast } from "primereact/toast";
import { useDispatch, useSelector } from "react-redux";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import CryptoJS from "crypto-js";
import { externalLinks } from "helpers/constant";
import { useHistory } from "react-router-dom";
import { env } from "process";
import { InputSwitch } from 'primereact/inputswitch';
import { Box } from "@mui/material";

export const Insurance = ({ corporate }) => {
  const application = "motor";
  const { i18n, t } = useTranslation();
  const toast = useRef(null);
  const dispatch = useDispatch();
  const [token, setToken] = useState("");
  const [showOTP, setShowOTP] = useState(null);
  const [custData, setcustData] = useState(null);
  const [yearsSelectList, setYearsSelectList] = useState([]);
  const [motorAnalytics, setMotorAnalytics] = useState(false);
  const history = useHistory();

  const selectedLanguage = localStorage.getItem("newTawuniyaLanguageParam");
  const userID = useSelector(
    (state) => state?.loginDetailsReducer?.loginResponse?.user_info?.userID
  );
  useEffect(() => {
    const years = getGregYearOfBirthList();
    setYearsSelectList(years);
  }, []);

  const openInNewTab = (url1) => {
    const newWindow = window.open(url1, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const insuranceMotorCardData = [
    {
      id: 0,
      content: t("motorPageData.detailSection.submitTrackaClaim"),
      cardIcon: claim,
      class: "pr-lg-0 pb-lg-0 pb-2",
      link: "/dashboard/all-claims",
    },
    {
      id: 1,
      content: t("motorPageData.detailSection.roadSideAnd"),
      cardIcon: accident,
      class: "pr-lg-0 pb-lg-0 pb-2",
      link: "/dashboard/service/road-assistance",
    },
    {
      id: 2,
      content: t("motorPageData.detailSection.mVPService"),
      cardIcon: mvpi,
      class: "pr-lg-0 pb-lg-0 pb-2",
      link: "/individuals/customer-service/periodic-inspection",
    },
    {
      id: 3,
      content: t("motorPageData.detailSection.freeTrip"),
      cardIcon: agent,
      class: "pr-lg-0 pb-lg-0 pb-2",
      link: "/dashboard/all-claims",
    },
  ];

  let dialingCodes = [
    {
      code: "+966",
      image: KSAFlagImage,
    },

  ];

  const [inpOne, setInpOne] = useState({
    userId: "",
    phone: "",
    birthYear: "",
  });
  const [radioOne, setRadioOne] = useState("Yes");
  let [selectedCode, setSelectedCode] = useState(dialingCodes[0]);
  let [phoneNumber, setPhoneNumber] = useState("");
  let [tabForm, setTabForm] = useState(true);
  let [selectedTab, setSelectedTab] = useState(1);

  const currentLanguage = getI18n().language;
  let buyNowLink =
    currentLanguage === "ar"
      ? "https://www.tawuniya.com/ar/individuals"
      : "https://www.tawuniya.com/en/individuals";

  const handleFormTab = (activeTab, number) => {
    setTabForm(activeTab);
    setSelectedTab(number);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target || e || {};
    setInpOne({ ...inpOne, [name]: value });
  };

  const handleBuyNowClick = () => {
    console.log(inpOne.userId && phoneNumber, "inpOne###");
    let linkURL = selectedTab == 1 ? buyNowLink : "https://smemotor.tawuniya.com.sa/";
    if (inpOne.userId && phoneNumber && inpOne.birthYear) {
      openInNewTab(linkURL);
    }
  };
  const handleSubmit = () => formik.submitForm();

  const ValidationSchema = Yup.object().shape({});

  const isValidSaudiIDOrIQama = (idNumber) => {
    return /^[1,2]{1}[0-9]{10}$/i.test(idNumber);
  };

  const isValidSaudiPhoneNumber = (value) => {
    return /^(5)(5|0|3|6|4|9|1|8|7)([0-9]{8})$/.test(value);
  };
  const [months, setMonths] = useState([
    { label: '01', value: '01' },
    { label: '02', value: '02' },
    { label: '03', value: '03' },
    { label: '04', value: '04' },
    { label: '05', value: '05' },
    { label: '06', value: '06' },
    { label: '07', value: '07' },
    { label: '08', value: '08' },
    { label: '09', value: '09' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
  ]);

  const getDays = () => {
    const arr = [];
    for (let index = 1; index <= 31; index++) {
      arr.push({ label: index.toString().padStart(2, '0'), value: index.toString().padStart(2, '0') })
    }
    return arr;
  }

  const [days, setDays] = useState(getDays());

  const formik = useFormik({
    initialValues: {
      //corporate: corporate,
      idNumber: "",
      yearOfBirth: "",
      mobileNumber: "",
      monthOfBirth: "",
      dayOfBirth: "",
      hjri: false
    },

    validationSchema: ValidationSchema,
    validate: (data) => {
      let errors = {};
      if (application === "motor" && !data.idNumber) {
        errors.idNumber = t("idRequired");
      } else if (
        (application === "motor" && isValidSaudiIDOrIQama(data.idNumber)) ||
        data.idNumber.length !== 10
      ) {
        errors.idNumber = t("idNotValid");
      }
      if (application === "motor" && !data.mobileNumber) {
        errors.mobileNumber = t("mobRequired");
      } else if (
        application === "motor" &&
        isValidSaudiPhoneNumber(data.mobileNumber)
        //||
        //data.mobileNumber.length !== 9
      ) {
        errors.mobileNumber = t("mobNotValid");
      }
      if (application === "motor" && !data.yearOfBirth) {
        errors.yearOfBirth = t("yobRequired");
      }
      if (application === "motor" && !data.monthOfBirth) {
        errors.monthOfBirth = t("monthRequired");
      }
      if (application === "motor" && !data.dayOfBirth && data.hjri) {
        errors.dayOfBirth = t("dayOfBirth");
      }
      console.log(data, "data####", data.mobileNumber, errors);
      return errors;
    },
    onSubmit: (data) => {
      window.lmSMTObj.track("motorBuyNow", {
        // "idNumber": data.idNumber,
        // "monthOfBirth": data.monthOfBirth,
        // "yearOfBirth": data.yearOfBirth,
        // "mobileNumber": data.mobileNumber
      });
      redirectMotorPage(data);
    },
  });

  function encrypt(value) {
    const idx = process.env.REACT_APP_EXTERNAL_IDX;
    const message = CryptoJS.AES.encrypt(value, idx);
    return message.toString();
  }

  useEffect(() => {
    formik.setFieldValue('yearOfBirth', '');
    formik.setFieldValue('monthOfBirth', '');
    formik.setFieldValue('dayOfBirth', '');
  }, [formik.values.hjri]);

  // check if the customer is saudi Or Not
  let isSaudi = formik?.values?.idNumber?.charAt(0) === '1';

  const redirectMotorPage = (data) => {
    let url =
      externalLinks.Motor + "?id=" +
      encrypt(data.idNumber) +
      "&mobile=" +
      encrypt(data.mobileNumber) +
      "&yob=" +
      encrypt(data.yearOfBirth) +
      "&mob=" +
      encrypt(data.monthOfBirth) +
      "&dob=" +
      encrypt(data.dayOfBirth) +
      "&hijri=" + data.hjri
      ;
    window.location.assign(url);
  };

  useEffect(() => {
    if (
      formik.values.idNumber.length === 0 &&
      formik.values.mobileNumber.length === 0 &&
      formik.values.yearOfBirth.length === 0
    ) {
      setMotorAnalytics(false);
    }
    if (
      application === "motor" &&
      !motorAnalytics &&
      (formik.values.idNumber.length > 0 ||
        formik.values.mobileNumber.length > 0 ||
        formik.values.yearOfBirth.length > 0)
    ) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "select_item",
        ecommerce: {
          funnel_step: "step_1",
          step_name: "motor_policy_new_select_item",
          items: [
            {
              item_name: "Motor Insurance New",
              item_category: "Motor Insurance",
              item_class: "Individual",
            }
          ]
        }
      });
      setMotorAnalytics(true);
    }
  }, [formik.values.idNumber, formik.values.mobileNumber, formik.values.yearOfBirth]);

  const sendOTPHandler = (data) => {
    getCustomerDetails(data).then((response) => {
      const temp = response?.verificationData;
      if (response?.resultCode === "S") {
        setToken(temp);
        setShowOTP(true);
      } else if (response?.resultCode === "V") {
        toast.current.show({
          severity: "error",
          summary: t("Error"),
          detail: response?.resultMessage,
          life: 3000,
          closable: false,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: t("Error"),
          detail: t("InfoError"),
          life: 3000,
        });
      }
    });
  };
  const verifyOTPHandler = (otp) => {
    let mobileNumber = "";
    let OtpID = custData.idNumber;
    console.log(custData.idNumber);
    if (custData.customerInformation.policyHolder[0].mobile.substring(0, 3) === "966") {
      mobileNumber = +custData.customerInformation.policyHolder[0].mobile;
    } else if (custData.customerInformation.policyHolder[0].mobile.substring(0, 4) === "+966") {
      mobileNumber = custData.customerInformation.policyHolder[0].mobile;
    } else {
      mobileNumber = "+966" + custData.customerInformation.policyHolder[0].mobile;
    }
    verifyOTP(mobileNumber, otp, OtpID).then((response) => {
      if (response?.data?.status === "1") {
        setShowOTP(false);
        window.location.assign(externalLinks.Motor)
      } else {
        toast.current.show({
          severity: "error",
          summary: t("Error"),
          detail: t("OtpError"),
          life: 3000,
        });
        console.error(response);
      }
    });
  };

  const verifyOTP = async (mobileNumber, otpCode, OtpID) => {
    dispatch(updateLoader(true));
    try {
      const response = await instance.post(
        "/common/validateOTPLanding",
        verifyOTPRequest(mobileNumber, otpCode, OtpID),
        {
          headers: {
            Authorization:
              "Bearer" + " " + store.getState().loginDetailsReducer?.loginResponse?.user_info?.token,
          },
        }
      );
      dispatch(updateLoader(false));
      return response;
    } catch (err) {
      dispatch(updateLoader(false));
      console.log("Error : ", err);
    }
  };
  const verifyOTPRequest = (mobileNumber, otp, OtpID) => {
    return {
      mobile: mobileNumber,
      channel: "Portal",
      otpCode: otp,
      language: i18n.language === "ar" ? "1" : "2",
    };
  };
  const getCustomerDetails = async (data) => {
    dispatch(updateLoader(true));
    try {
      const response = await instance.post(
        "/motorRetail/getCustomerDetails",
        {
          applicationType: "TAWN",
          consumerTrackingID: "75678",
          idNumber: `${data.idNumber}`,
          languageCode: i18n.language.slice(0, 1).toUpperCase(),
          requestGeneratedTime: null,
          yearOfBirth: data.yearOfBirth.toString(),
          email: "test@gmail.com",
          mobileNumber: "+966" + data.mobileNumber,
          channelDetails: {
            applicationType: "TAWN",
            applicationCategory: "RH",
            userName: "EBUSUSER",
            sourceCode: "550541",
            channelCode: "RH",
            branchCode: "85",
          },
        },
        {
          headers: {
            Authorization:
              "Bearer" + " " + store.getState().loginDetailsReducer?.loginResponse?.user_info?.token,
          },
        }
      );
      setcustData(response.data);
      dispatch(updateLoader(false));
      return response.data;
    } catch (err) {
      dispatch(updateLoader(false));
      console.error(err);
    }
  };

  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  const handleClicks = (val) => {
    if (val === 1) {
      let link = val === 1 ? "/dashboard/policy-detail" : externalLinks.Renewal + "renewal?lang=en";
      if (userID) {
        history.push(link)
      } else {
        history.push('/login/')
      }
    }
    else {
      window.location.assign(`${process.env.REACT_APP_PURCHASE_URL_TRAVEL}renewal?lang=${i18n.language}`);
    }
  }

  const getYearList = () => {
    if (formik.values.hjri) {
      const hijriCurrentYear = Math.round((new Date().getFullYear() - 623) * (33 / 32));
      const hijriThresholdYear = hijriCurrentYear - 16;

      return getHijriYearOfBirthList().filter((item) => Number(item.value) <= hijriThresholdYear);
    } else {

      return getGregYearOfBirthList().filter((item) => Number(item.value) <= new Date().getFullYear() - 16);
    }
  };


  const trackEvent = (tabClicked) => {
    window.lmSMTObj.track(tabClicked);
  }

  return (
    <div className="row motorInsuranceContainer pt-3 pb-5">
      <Toast ref={toast} />
      <div className="col-lg-7 col-12 pt-5">
        <div className="row">
          <div className="col-lg-11 col-12">
            <p className="motorTitle fw-800 m-0 pt-3">{t("motorPageData.detailSection.detailTitle")}</p>
            <p className="motorPara fs-21 fw-400">{t("motorPageData.detailSection.detailPara")}</p>
            <InsuranceCard heathInsureCardData={insuranceMotorCardData} textWidth="insureCardTextWidth" />
            <div className="row positionReward-ManageCard">
              <div className="col-lg-6 col-md-12 col-12 pt-1 pb-lg-0 pb-md-3 pr-lg-0">
                <div className="managePolicy">
                  <div className="policyContainer">
                    <div className="d-flex flex-row align-items-center">
                      <div className="add-icon">
                        <img src={addManage} className="img-fluid addManageIcon" alt="addManage" />
                      </div>
                      <div>
                        <p className="manageText fs-20 fw-800 m-0">{t("motorPageData.managePolicy.title")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="policyTypeContainer p-4">
                    <div className="row">
                      <div
                        className="col-lg-6 col-md-4 col-12 vehilcleBox pr-3 c-pointer"
                        onClick={() => { handleClicks(1); trackEvent(t("motorPageData.managePolicy.downloadPolicy") + "Clicked") }}
                      >
                        <DownloadPolicy />
                        <p className="policyBoxPara fs-14 fw-400 m-0">
                          {t("motorPageData.managePolicy.downloadPolicy")}
                        </p>
                      </div>
                      <div
                        className="col-lg-6 col-md-4 col-12 vehilcleBox pr-3 c-pointer"
                        onClick={() => { handleClicks(2); trackEvent(t("motorPageData.managePolicy.renewPolicy") + "Clicked") }}
                      >
                        <img src={renew} className="img-fluid mx-auto d-block pb-2" alt="renew" />
                        <p className="policyBoxPara fs-14 fw-400 m-0">
                          {t("motorPageData.managePolicy.renewPolicy")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-12">
                <RewardCard
                  cardTitle={t("motorPageData.managePolicy.drive")}
                  cardSubTitle={t("motorPageData.managePolicy.driveText")}
                  titleClass="rewardTitle"
                  subtitleClass="rewardSubTitle"
                  label={t("motorPageData.managePolicy.claimRewards")}
                  className="rewardBtnClass"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-5 col-md-12 col-12 pt-lg-5 pt-2" id={"insuranceForm"}>
        <div className="insureMotorCard h-100">
          <div className="insureLayerOne">
            <p className="insureCardTitle fw-800 m-0">{t("motorPageData.insureYourVehicle")}</p>
          </div>
          <div className="insureLayerTwo">
            <div className="insurance-form-wrapper">
              <div className="col-lg-12">
                <GenericButton
                  alignBtn={true}
                  label={t("motorPageData.individual")}
                  className={`${tabForm ? "active" : ""}`}
                  needNewBtnIcon={true}
                  newSrc={!tabForm ? singleOrange : single}
                  adjustNewIcon="img-fluid icon"
                  onClick={() => handleFormTab(true, 1)}
                />
              </div>
            </div>

            <div className="subInsureLayer p-4">
              <div className="row">
                <div className="col-12">
                  <NormalSearch
                    className="motorInputfieldOne"
                    name="idNumber"
                    placeholder={t("banner.iqamaNumberPlaceholder")}
                    value={formik.values.idNumber}
                    error={formik.errors.idNumber}
                    fromMotor={true}
                    maxLength={10}
                    onChange={formik.handleChange}
                    needLeftIcon={true}
                    leftIcon={iquamaIcon}
                  />
                  {getFormErrorMessage("idNumber")}
                </div>
                {application === "motor" && isSaudi && (
                  <Box className="d-flex  gap-2 align-items-center justify-content-start px-4 mt-2">
                    <small>{t("banner.HijriDate")}</small>
                    <InputSwitch
                      size="small"
                      name="hjri"
                      id="hjri"
                      value={formik.values.hjri}
                      error={formik.errors.hjri}
                      onChange={formik.handleChange}
                      checked={formik.values.hjri}
                      style={{ transform: "scale(0.7)" }}
                    />
                  </Box>
                )}
                <div className="col-12 pt-2">
                  <NormalSelect
                    className="select-box-motor searchBox searchBox-rtl padLeftIcon"
                    arrowVerticalAlign="bannerArrowAlign"
                    selectArrow={selectArrow}
                    selectControlHeight="22px"
                    selectFontWeight="400"
                    placeholder={t("banner.yearOfBirthPlaceholder")}
                    name="yearOfBirth"
                    id="yearOfBirth"
                    options={getYearList()}
                    value={formik.values.yearOfBirth}
                    error={formik.errors.yearOfBirth}
                    onChange={formik.handleChange}
                    setFieldValue={formik.setFieldValue}
                    needLeftIcon={true}
                    leftIcon={calenderIcon}
                  />
                  {getFormErrorMessage("yearOfBirth")}
                </div>
                <div className="col-12 pt-4">
                  <NormalSelect
                    className="select-box-motor searchBox searchBox-rtl padLeftIcon"
                    arrowVerticalAlign="bannerArrowAlign"
                    selectArrow={selectArrow}
                    selectControlHeight="22px"
                    selectFontWeight="400"
                    placeholder={t("banner.monthOfBirthPlaceholder")}
                    name="monthOfBirth"
                    id="monthOfBirth"
                    options={months}
                    value={formik.values.monthOfBirth}
                    error={formik.errors.monthOfBirth}
                    onChange={formik.handleChange}
                    setFieldValue={formik.setFieldValue}
                    needLeftIcon={true}
                    leftIcon={calenderIcon}
                  />
                  {getFormErrorMessage("monthOfBirth")}
                </div>
                {formik.values.hjri ?
                  <div className="col-12 pt-4">
                    <NormalSelect
                      className="select-box-motor searchBox searchBox-rtl padLeftIcon"
                      arrowVerticalAlign="bannerArrowAlign"
                      selectArrow={selectArrow}
                      selectControlHeight="22px"
                      selectFontWeight="400"
                      placeholder={t("banner.dayOfBirthPlaceholder")}
                      name="dayOfBirth"
                      id="dayOfBirth"
                      options={days}
                      value={formik.values.dayOfBirth}
                      error={formik.errors.dayOfBirth}
                      onChange={formik.handleChange}
                      setFieldValue={formik.setFieldValue}
                      needLeftIcon={true}
                      leftIcon={calenderIcon}
                    />
                    {getFormErrorMessage("dayOfBirth")}
                  </div>
                  : ''}
                <div className="col-12 pt-4">
                  <InputText
                    placeholder={t("contactUs.country_code_placeholder")}
                    name="mobileNumber"
                    id="mobileNumber"
                    value={formik.values.mobileNumber}
                    error={formik.errors.mobileNumber}
                    onChange={formik.handleChange}
                    maxlength="9"
                    inputMode="numeric"
                    keyfilter="int"
                    className={
                      classNames({
                        "p-invalid  inpThreeField border-0 select-box-motor searchBox searchBox-rtl padLeftIcon":
                          isFormFieldValid("ibanNo"),
                      }) + "font-bliss  px-3 w-100"
                    }
                  />
                  {getFormErrorMessage("mobileNumber")}

                </div>
              </div>
            </div>
            <div className="termsContainer">
              <p className="fs-15 fw-400 insureTerms">{t("motorPageData.disclaimer")}</p>
              <div className="pb-3 mb-2" id="position-BuyBtn">
                <GenericButton
                  label={t("motorPageData.buyNow")}
                  className="active center"
                  adjustIcon="margin-start"
                  needBtnPic={true}
                  src={buynowArrow}
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
        {console.log(formik.values.mobileNumber, "nnumber")}
        {showOTP && (
          <OtpPage
            verifyOTP={verifyOTPHandler}
            sendOTP={sendOTPHandler}
            closeOTP={() => setShowOTP(false)}
            mobileNumber={formik.values.mobileNumber.toString()}
          />
        )}
      </div>
    </div>
  );
};
